export default "__VITE_ASSET__CdTAeMtx__"